import React, { Fragment } from "react";
import Breadcrumb from "../../../../layout/breadcrumb";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Card } from 'reactstrap';
import BulkInvoiceWalletClaim from "./invoices/bulk-invoice-wallet-claim";

const MscBulkClaimCpg = () => {
  return (
    <Fragment>
      <Breadcrumb parent="Bulk Document" title="MSC Bulk Claim - CPG" />
      <Card style={{ padding: "5px" }}>
        <BulkInvoiceWalletClaim isCpg={true} />
      </Card>
    </Fragment>
  );
};

const MscBulkClaimCpgPage = () => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <MscBulkClaimCpg />
  </LocalizationProvider>
);

export default MscBulkClaimCpgPage;
